
// import logo from "../../../assets/logo/LOGO-dark.png";
// import logo from "../../../assets/logo/image.png";
import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { keyframes } from "@emotion/react";

// Fade-in animation
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const LoadingIndicator = ({ message = "Loading, please wait...", showLogo = true }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "40vh",
        animation: `${fadeIn} 0.6s ease-in-out`,
      }}
    >
      {/* {showLogo && (
        <Box
          component="img"
          src={logo}
          alt="Logo"
          sx={{
            width: 80,
            height: 80,
            mb: 2,
            opacity: 0.8,
            filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
          }}
        />
      )} */}
      <CircularProgress size={50} thickness={4} />
      <Typography
        variant="subtitle1"
        color="textSecondary"
        sx={{ mt: 2, fontStyle: "italic" }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingIndicator;
